// extracted by css-extract-rspack-plugin
export default {"cls1":"BulkDownloadPing-cls1_ozU","cls2":"BulkDownloadPing-cls2_wKX BulkDownloadPing-cls1_ozU"};